export const rcpaxaFormules = [
  'STARTER',
  'STARTER_PLUS',
  'FORMULE_1',
  'FORMULE_2',
  'FORMULE_3',
  'VTC_FORMULE_A',
  'VTC_FORMULE_B',
  'VTC_FORMULE_C',
] as const
export type RcpaxaFormule = (typeof rcpaxaFormules)[number]

export type RcpaxaSource = 'hub' | 'funnel'

export type RcpaxaQuoteFailure =
  | {
      type: 'pricing-issue'
    }
  | {
      type: 'no-pricing-version'
    }
  | {
      type: 'has-exclusions'
    }
  | {
      type: 'no-activity-selected'
    }
  | {
      type: 'no-estimated-revenue'
    }
  | {
      type: 'no-rcpaxa-pricing-category'
    }
  | {
      type: 'no-rcpaxa-formule'
    }
  | {
      type: 'activity-not-pricable'
      activity: string
    }
